import React from "react";

function Packed({ width = 20, height = 20, fill = "#F8F6F6" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0588 4.65478L10.5587 0.904782C10.3853 0.818084 10.194 0.772949 10 0.772949C9.80604 0.772949 9.61475 0.818084 9.44125 0.904782L1.94125 4.65478C1.73365 4.75852 1.55903 4.918 1.43694 5.11537C1.31485 5.31274 1.25012 5.5402 1.25 5.77228V14.2273C1.25012 14.4594 1.31485 14.6868 1.43694 14.8842C1.55903 15.0816 1.73365 15.241 1.94125 15.3448L9.44125 19.0948C9.61475 19.1815 9.80604 19.2266 10 19.2266C10.194 19.2266 10.3853 19.1815 10.5587 19.0948L18.0588 15.3448C18.2663 15.241 18.441 15.0816 18.5631 14.8842C18.6851 14.6868 18.7499 14.4594 18.75 14.2273V5.77228C18.7499 5.5402 18.6851 5.31274 18.5631 5.11537C18.441 4.918 18.2663 4.75852 18.0588 4.65478ZM7.33875 7.37103L14.0175 4.03103L16.715 5.37978L10 8.67853L7.33875 7.37103ZM10 2.02228L12.62 3.33228L5.92875 6.67853L3.285 5.37978L10 2.02228ZM2.5 6.38728L5.3125 7.76853V11.2498C5.3125 11.4155 5.37835 11.5745 5.49556 11.6917C5.61277 11.8089 5.77174 11.8748 5.9375 11.8748C6.10326 11.8748 6.26223 11.8089 6.37944 11.6917C6.49665 11.5745 6.5625 11.4155 6.5625 11.2498V8.38228L9.375 9.76353V17.6648L2.5 14.2273V6.38728ZM10.625 17.6648V9.76478L17.5 6.38728V14.2273L10.625 17.6648Z"
        fill={fill}
      />
    </svg>
  );
}

export default Packed;
